function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import 'regenerator-runtime/runtime';
import breakpointHelper from 'breakpoint-helper';
var _require = require('../config/silo/tailwind.json'),
  tailwind = _require.tailwind;
var screens = tailwind.theme.screens;
var bph = breakpointHelper(screens);
var breakpointDefaults = {
  isMobile: bph.isMatching('sm', true),
  isTablet: bph.isMatching(['sm', 'lg']),
  isTouch: bph.isMatching('lg', true),
  isDesktop: bph.isMatching('lg'),
  isDesktopXl: bph.isMatching('xl')
};
window.Breakpoint = breakpointDefaults;
export var breakpoint = breakpointDefaults;
var breakpointStatus = function breakpointStatus(e, name) {
  var matches = e.matches;
  var capitalizedName = "".concat(name.charAt(0).toUpperCase()).concat(name.slice(1));
  window.Breakpoint["is".concat(capitalizedName)] = matches;
  breakpoint["is".concat(capitalizedName)] = matches;
  return matches;
};
var isMobile = bph.listen({
  name: 'sm',
  useMax: true,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'mobile');
});
var isTablet = bph.listen({
  name: ['sm', 'lg'],
  useMax: false,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'tablet');
});
var isTouch = bph.listen({
  name: 'lg',
  useMax: true,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'touch');
});
var isDesktop = bph.listen({
  name: 'lg',
  useMax: false,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'desktop');
});
var isDesktopXl = bph.listen({
  name: 'xl',
  useMax: false,
  immediate: true
}, function (e) {
  return breakpointStatus(e, 'desktopXl');
});
export var BreakpointHelper = _objectSpread(_objectSpread({}, bph), {}, {
  isMobile: isMobile,
  isTablet: isTablet,
  isTouch: isTouch,
  isDesktop: isDesktop,
  isDesktopXl: isDesktopXl
});
window.BreakpointHelper = BreakpointHelper;